import angular from 'angular';

import application from 'application/application';

application

	.directive('ngChecklist', ['$timeout', '$parse', ($timeout, $parse) => {

		const

			checkParents = checkbox => {

				checkbox = angular.element(checkbox);

				var

					checkedProp = $(checkbox).closest('ul[ng-checklist]').attr('ng-checked-prop'),

					checkboxScope = checkbox.scope(),

					item = $parse(checkbox.attr('ng-item'))(checkboxScope),

					parent = $parse(checkbox.attr('ng-item-parent'))(checkboxScope);

				if (parent) {

					let

						parentCheckbox = $(checkbox).closest('ul').closest('li').find('input[type="checkbox"]:first'),

						siblings = parentCheckbox.closest('li').find('input[type="checkbox"]').not(parentCheckbox);

					if (item[checkedProp]) {

						parent[checkedProp] = true;

					} else if (siblings.filter(':checked').length === 0) {

						parent[checkedProp] = false;

					}

					checkParents(parentCheckbox);

					parentCheckbox.prop('indeterminate', siblings.filter(':checked').length > 0 && siblings.filter(':checked').length !== siblings.length);

				}

			};

		return {
			restrict: 'A',
			link(scope, element) {

				$timeout(() => {

					$(element).find('input[type="checkbox"]').each(function() {

						checkParents(this);

					});

					scope.$apply();

				});

				$(element).on('change', 'input[type="checkbox"]', function() {

					$timeout(() => checkParents(this));

				});

			}
		};

	}]);
